import React, { useContext } from 'react'
import { getCategoryJp } from '../../utils/news'
import { style as universityStyle } from './Index.style'
import { style } from './Project.style'
import Content from '../Content/Content'
import SectionTitle from '../SectionTitle/SectioinTitle'
import { CategoryContext } from './CategoryContext'
import { commonStyle as homeStyle } from '../Home/Index.style'

const Project = () => {
  const category = useContext(CategoryContext)
  return (
    <section>
      <Content>
        <SectionTitle
          sectionSubTitle="PROJECT"
          sectionTitle={`${getCategoryJp(category)}大学の取り組み`}
        />
        <div css={style.body}>
          <div css={style.block}>
            <p>
              富山大学と新潟大学は、大学間連携によるデジタルコンテンツの共有化などの相補的かつ効果的な医学教育システムの構築に取り組みます。「地域を守る医療人養成プログラム(エッセンシャルコース)」として、1–6年次の全医学生を対象とした教育プログラム・コースを各大学に設定します。また、富山・新潟大学「地域を守る医療人養成プログラム(アドバンスドコース)」として、地域枠学生や希望学生を対象とした地域医療構想の重点支援区域で統合型教育を実施します。
            </p>
            <p>
              富山大学では、地域を守る医療人養成プログラム(エッセンシャルコース)として、1–6年次の全医学生を必修として、以下の教育の改変・拡充に取り組みます。
            </p>
            <ul css={style.list}>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>地域医療プロフェッショナリズム</span>
                </h3>
                <p>
                  行動科学、コミュニケーションとチーム医療、富山医療学、医療プロフェッショナリズム、医療学入門
                </p>
              </li>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>臨床医学的能力</span>
                </h3>
                <dl css={style.box}>
                  <div>
                    <dt css={style.boxTitle}>総合診療</dt>
                    <dd>
                      基本的診療技能、症候、病態からのアプローチ、総合診療、地域医療、海外地域医療実習
                    </dd>
                  </div>
                  <div>
                    <dt css={style.boxTitle}>感染症</dt>
                    <dd>微生物学、免疫学、感染症、感染症科</dd>
                  </div>
                </dl>
              </li>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>社会医学的能力</span>
                </h3>
                <p>疫学・公衆衛生学、救急医学・災害医学</p>
              </li>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>ICT運用能力</span>
                </h3>
                <p>基礎医学統合、臨床医学統合</p>
              </li>
            </ul>
          </div>
          <div css={style.block}>
            <p>
              新潟大学では、地域を守る医療人養成プログラム(エッセンシャルコース)として、1–6年次の全医学生を必修として、以下の教育の改変・拡充に取り組みます。
              <br />
              また、その際には修得することが求められた4つのコンピテンシーに対応する科目を決めて、講義・実習内容に反映させていきます。
            </p>
            <ul css={style.list}>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>講座型科目</span>
                </h3>
                <p>
                  医学入門、プロフェッショナリズム教育、行動科学、統合臨床医学、臨床実習入門:地域医療
                </p>
              </li>
              <li>
                <h3 css={homeStyle.subHead('yellow')}>
                  <span>実習型科目</span>
                </h3>
                <p>早期医学体験実習</p>
                <dl>
                  <div css={style.areaBlock}>
                    <dt>臨床実習I:</dt>
                    <dd>救急医学講座、総合診療学講座、地域医療分野</dd>
                  </div>
                  <div css={style.areaBlock}>
                    <dt>臨床実習II:</dt>
                    <dd>総合診療学講座、地域医療分野</dd>
                  </div>
                </dl>
              </li>
            </ul>
          </div>
        </div>
      </Content>
    </section>
  )
}

export default Project
